module.exports = __webpack_public_path__ + "img/soccer_half.04c63767.svg";